module.exports = __webpack_public_path__ + "static/media/degas-9.80ff4d51.jpeg";